<template>
  <div class="map-wrapper">
    <GmapMap
      ref="mapRef"
      :center="{lat:48.8577392, lng:2.3365915}"
      :zoom="16"
      class="map"
      map-type-id="terrain"
    />
  </div>
</template>


<script>
import { gmapApi } from 'vue2-google-maps';
import axios from 'axios';

export default {
  props: {
    results: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      map: null,
    };
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    results() {
      this.map.setCenter(this.results[0].geometry.location);
      const coords = this.results[0].geometry.location;
      this.map.setCenter(coords);
      this.map.setZoom(13);
      const populationOptions = {
        strokeColor: '#0000ff',
        strokeOpacity: 0.5,
        strokeWeight: 2,
        fillColor: '#0000ff',
        fillOpacity: 0.15,
        map: this.map,
        center: coords,
        radius: parseInt(2 / 0.001, 0),
      };
      if (this.areaPath) this.areaPath.setMap(null);
      this.areaPath = new this.google.maps.Circle(populationOptions);
    },
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
      this.loadMarkers();
    });
  },
  methods: {
    async loadMarkers() {
      try {
        const result = await axios.get(`${this.$store.state.basePath}/assets/stores.csv`);
        this.parseData(result.data);
      } catch (e) {
        // console.info('ERROR LOADING');
      }
    },
    parseData(data) {
      const arraydata = data.split(/\r?\n/);
      let currentsplit;
      let myLatlng;
      let marker;
      let i = 0;
      const length = arraydata.length;
      let title = '';
      this.infoWindow = new this.google.maps.InfoWindow({
        content: 'Chargement...',
      });
      for (i = 1; i < length; i += 1) {
        if (arraydata[i] === '') break;
        currentsplit = arraydata[i].split('|');
        myLatlng = new this.google.maps.LatLng(parseFloat(currentsplit[3].replace(',', '.')), parseFloat(currentsplit[4].replace(',', '.')));
        title = `<div title="" max-width:200px"><strong>${currentsplit[0]}</strong><br/>${currentsplit[1]}<br/>${currentsplit[2]}</div>`;
        marker = new this.google.maps.Marker({
          position: myLatlng,
          content: title,
          infoWindowIndex: i,
        });
        this.addRollOverMarker(marker);
        marker.setMap(this.map);
        // this.markers.push(marker);
      }
    },
    addRollOverMarker(marker) {
      this.google.maps.event.addListener(marker, 'mouseover', () => {
        this.infoWindow.setContent(marker.content);
        this.infoWindow.open(this.map, marker);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.vue-map-container,
.map-wrapper { height: 100%; }
</style>
